import styled from 'styled-components'
import ReactGA from 'react-ga4'
import LeftBar from '../home/components/leftBar'
import Inexigibilidade from './Inexigibilidade'

const Page = styled.div`
    display: flex;
    height: 100vh;
    overflow: hidden !important;
`

export default function ContratacaoDireta() {
    ReactGA.send({
        hitType: 'pageview',
        page: '/contratacao-direta',
        title: 'Contratação direta',
    })
    return (
        <Page>
            <LeftBar />
            <Inexigibilidade />
        </Page>
    )
}
